import { Component, Inject } from "@angular/core";
import { WindowToken } from "@app/util/window.token";

/**
 * Created by mac90082 on 10/26/16.
 * Not currently used since we're linking to an external privacy policy page.
 */
@Component({
    selector: 'app-privacy',
    template: require('./privacyPolicy.html')
})
export class PrivacyPolicyComponent {

    constructor(@Inject(WindowToken) private window) { }

    openUrl(url) {
        this.window.open(url, '_blank');
    }
}

